import {modelHydrator} from "./_modelHydrator";
import {documentResultType} from "../../types/Api/DocumentResultType";
import {document} from "../document";
import {conf} from "../../env";

export const documentHydrator = {
  hydrate: (document: documentResultType): document => {
    return Object.assign({
      documentId: document.documentId,
      label: document.label,
      slug: document.slug,
      position: document.position,
      lineBreak: document.lineBreak === 1,
      enabled: document.enabled === 1
    }, modelHydrator.hydrate(document))
  },
  downloadUrl: (document: document): string => {
    return `${conf.api.uri}/document/${document.documentId}/download`;
  }
}
